/**
 * Breakpoints should align with values defined in _breakpoints.scss
 */

export default {
  mobileSmall: 360,
  mobile: 480,
  tablet: 768,
  tabletMd: 850,
  desktop: 1024,
  desktopMd: 1200,
  desktopLg: 1440,
};
